import { IShippingCarrier } from '../model/IShippingCarrier';
import api from './api';

export type IShippingCarrierForm = Omit<IShippingCarrier, 'id'>;

export const shippingCarrierApi = api.injectEndpoints({
  endpoints: (build) => ({
    // GET /api/v1/shipping-carriers
    //
    // Readable by ADMIN, AGENT and VENDOR, because the tracking form's shipper
    // dropdown needs it. Everything below is ADMIN-only on the backend.
    getShippingCarriers: build.query<IShippingCarrier[], void>({
      query: () => ({
        url: 'shipping-carriers',
      }),
      providesTags: ['ShippingCarriers'],
    }),

    // PUT /api/v1/shipping-carriers
    createShippingCarrier: build.mutation<IShippingCarrier, IShippingCarrierForm>({
      query: (body) => ({
        url: 'shipping-carriers',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ShippingCarriers'],
    }),

    // POST /api/v1/shipping-carriers/{id}
    updateShippingCarrier: build.mutation<
      IShippingCarrier,
      { id: number } & Partial<IShippingCarrierForm>
    >({
      query: ({ id, ...body }) => ({
        url: `shipping-carriers/${id}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ShippingCarriers'],
    }),

    // DELETE /api/v1/shipping-carriers/{id} -- responds with plain text "ok"
    deleteShippingCarrier: build.mutation<unknown, number>({
      query: (id) => ({
        url: `shipping-carriers/${id}`,
        method: 'DELETE',
        responseHandler: 'text',
      }),
      invalidatesTags: ['ShippingCarriers'],
    }),
  }),
});
